// SCRUM-1614 (epic SCRUM-1609) — client for the stock-report web services
// (research-service, SCRUM-1612). No manual headers — the AuthInterceptor in
// main.ts attaches the JWT for all requests.

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  StockReportEnvelope,
  StockReportMeta,
  StockReportHistory,
} from '../models/stock-report.model';

@Injectable({ providedIn: 'root' })
export class StockReportService {
  private readonly API = '/api/research/stock-report';

  constructor(private readonly http: HttpClient) {}

  /** Latest full report for a ticker. 404 when none stored yet. */
  getReport(ticker: string): Observable<StockReportEnvelope> {
    return this.http.get<StockReportEnvelope>(`${this.API}/${ticker}`);
  }

  /** Freshness metadata only (no payload). 404 when none stored yet. */
  getMeta(ticker: string): Observable<StockReportMeta> {
    return this.http.get<StockReportMeta>(`${this.API}/${ticker}/meta`);
  }

  /** Enqueue a regeneration; the endpoint returns 202 immediately. */
  refresh(ticker: string): Observable<{ accepted: boolean; ticker: string; status: string }> {
    return this.http.post<{ accepted: boolean; ticker: string; status: string }>(
      `${this.API}/${ticker}/refresh`,
      {},
    );
  }

  /** SCRUM-1630 — every retained report for a ticker, newest first (metadata only). */
  getHistory(ticker: string): Observable<StockReportHistory> {
    return this.http.get<StockReportHistory>(`${this.API}/${ticker}/history`);
  }

  /** SCRUM-1630 — a specific past report by its id (read-only reopen). */
  getById(id: string): Observable<StockReportEnvelope> {
    return this.http.get<StockReportEnvelope>(`${this.API}/report/${id}`);
  }
}
